<template>
    <div class="content-card mb-5" >
      <div class="content-card-title d-flex justify-content-start flex-wrap gap-2">
            <button v-for="(filter, index) in filters" :key="index"
                :class="['btn', 'btn-filter', filter.active ? 'btn-outline-primary btn-active text-white' : 'btn-outline-secondary']"
                @click="setActiveFilter(index)">
                <i class="fa-icon fa-solid" :class="[filter.active ? 'fa-circle-check' : 'fa-circle']"></i>{{
                    filter.name }}
            </button>
        </div>

      <div class="content-card-body p-0 " >
          <app-casino  v-if="activeFilter == 1"/>
          <app-slot  v-if="activeFilter == 2"/>
          <app-sport  v-if="activeFilter == 3"/>
          <app-visualSport  v-if="activeFilter == 4"/>
          <app-fishing  v-if="activeFilter == 5"/>
      </div>
    </div>
  </template>
<script>
import casino from '@/components/sakha/game/casino'
import slot from '@/components/sakha/game/slot'
import sport from '@/components/sakha/game/sport'
import visualSport from '@/components/sakha/game/visualSport'
import fishing from '@/components/sakha/game/fishing'

export default {
  components: {
    'app-casino': casino,
    'app-slot': slot,
    'app-sport': sport,
    'app-visualSport': visualSport,
    'app-fishing': fishing
  },
  data () {
    return {
      filters: [
        { id: '1', name: 'คาสิโน', active: true },
        { id: '2', name: 'สล็อต', active: false },
        { id: '3', name: 'กีฬา', active: false },
        { id: '4', name: 'กีฬาจำลอง', active: false },
        { id: '5', name: 'ยิงปลา', active: false }
      ],
      activeFilter: 1
    }
  },
  async created () {

  },
  computed: {

  },
  methods: {
    setActiveFilter (index) {
      this.filters.forEach((filter, i) => {
        filter.active = i === index
      })
      this.activeFilter = this.filters[index].id
    }
  }
}
</script>

  <style scoped>
    .btn-active {
      background-color: #007bff;
      color: white;
    }
  </style>
